/**
 * A zona-sales step's month in words (bata-reqs issue 35 P3, bata-platform ADR 6075).
 *
 * A step priced on calendar months carries `effective_month` (the 1st); its `effective_week` is the
 * retail week that 1st falls in, kept so every older reader works. Where the month is set, a screen
 * names the month — «novembre 2026» — and the retail week stays the key.
 */

/** `YYYY-MM-DD` → its month in words. Pure over the locale. */
export function monthName(isoDate: string, locale: string): string {
  const [year, month] = isoDate.split('-').map(Number);
  if (year === undefined || month === undefined || Number.isNaN(year) || Number.isNaN(month)) return isoDate;
  return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(year, month - 1, 1)));
}

/** When a step takes effect: its month where it has one, else its retail week. Pure over the locale. */
export function stepWhen(step: { readonly effective_week: string; readonly effective_month?: string | null }, locale: string): string {
  return step.effective_month === null || step.effective_month === undefined ? step.effective_week : monthName(step.effective_month, locale);
}

/** A retail week in words: the month its steps take effect in, where they carry one, else the week. */
export function weekWhen(week: string, month: string | null | undefined, locale: string): string {
  return month === null || month === undefined ? week : monthName(month, locale);
}
